// extracted by mini-css-extract-plugin
export default {"ilClaim":"styles_ilClaim__sGf46","claimTitle":"styles_claimTitle__ze0n1"};